export const industries = [
  "Accountants", "Advertising & Marketing", "Agriculture & Farming", "Construction", 
  "Education", "Financial Services", "Healthcare", "Manufacturing", "Real Estate", 
  "Retail", "Technology", "Other"
];

export const currencies = [
  { code: "USD", name: "United States Dollar", symbol: "$" },
  { code: "CAD", name: "Canadian Dollar", symbol: "C$" },
  { code: "EUR", name: "Euro", symbol: "€" },
  { code: "GBP", name: "British Pound", symbol: "£" }
];

export const mockUsers = [
  { id: 1, name: 'Alejandra', email: 'alejandra@profityo.com', role: 'Owner', status: 'Active' },
  { id: 2, name: 'David Chen', email: 'david@cpa-firm.com', role: 'Accountant', status: 'Active' },
  { id: 3, name: 'Sarah Miller', email: 'sarah@profityo.com', role: 'Bookkeeper', status: 'Active' }
];

export const mockAuditTrail = [
  { id: 1, user: 'Alejandra', action: 'Changed Accounting Method', detail: 'Cash to Accrual', date: '2026-07-15 10:30 AM' },
  { id: 2, user: 'Alejandra', action: 'Updated EIN', detail: '98-XXXXXXX', date: '2026-07-10 02:15 PM' },
  { id: 3, user: 'David Chen', action: 'Added New User', detail: 'Sarah Miller (Bookkeeper)', date: '2026-07-05 09:00 AM' }
];